import React, { createContext, useContext, useState } from 'react';
import { useAuth } from './AuthContext';
import Swal from 'sweetalert2';
const ErrorContext = createContext(null);
export const ErrorProvider = ({ children }) => {
  const [formErrors, setFormErrors] = useState({});
  const { logout } = useAuth();
  const handleApiError = (error, options = {}) => {
    
    const {
      showAlert = true,
      redirectOn401 = true,
      customMessage = null
    } = options;
    // Handle 401 Unauthorized
    if (error.status === 401 && redirectOn401) {
      logout();
      return false;
    }
    // Handle validation errors
    if (error.validationErrors?.length > 0) {
      setFormErrors(error.validationErrors);
    } 
    // Handle API error messages
    else if (error?.data?.message) {
      if (typeof error.data.message === 'string') {
        setFormErrors({ general: <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mt-2" role="alert"><strong className="font-bold">Error: </strong><span className="block sm:inline">{error?.data?.message }</span></div> });
      
      } else {
        
        setFormErrors({ general:<div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mt-2" role="alert"><strong className="font-bold">Error: </strong><span className="block sm:inline">{error?.data?.message }</span></div>});
       
      }
    } 
    // Handle general error messages
    else if (error?.message) {
      setFormErrors({ general: <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mt-2" role="alert"><strong className="font-bold">Error: </strong><span className="block sm:inline">Oops! Something went wrong.
An unexpected error occurred. Please try again later or contact support if the issue persists.</span></div> });
       
    } 
    // Handle custom messages
    else if (customMessage) {
      setFormErrors({ general: <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mt-2" role="alert"><strong className="font-bold">Error: </strong><span className="block sm:inline">Oops! Something went wrong.
An unexpected error occurred. Please try again later or contact support if the issue persists.</span></div> });
     
    }
    // Default error
    else {
      setFormErrors({ general: <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mt-2" role="alert"><strong className="font-bold">Error: </strong><span className="block sm:inline">An error occurred. Please try again.</span></div> });
      
    }
    // Show alert if enabled
    if (showAlert) {
      Swal.fire({
        title: 'Error',
        text: formErrors.general || 'An error occurred',
        icon: 'error'
      });
    }  
    return false;
  };  
  const clearErrors = () => {
    setFormErrors({});
  };
  return (
    <ErrorContext.Provider value={{
      formErrors,
      handleApiError,
      clearErrors,
      setFormErrors
    }}>
      {children}
    </ErrorContext.Provider>
  );
};
export const useError = () => {
  const context = useContext(ErrorContext);
  if (!context) {
    throw new Error('useError must be used within an ErrorProvider');
  }
  return context;
}; 
 